import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';

import { addNotification } from 'redux/modules/notifications';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const ACCOUNT_LOGIN = 'ACCOUNT_LOGIN';
export const ACCOUNT_LOGIN_SUCCESS = 'ACCOUNT_LOGIN_SUCCESS';
export const ACCOUNT_LOGIN_FAIL = 'ACCOUNT_LOGIN_FAIL';
export const ACCOUNT_LOGOUT = 'ACCOUNT_LOGOUT';
export const ACCOUNT_LOGOUT_SUCCESS = 'ACCOUNT_LOGOUT_SUCCESS';
export const ACCOUNT_LOGOUT_FAIL = 'ACCOUNT_LOGOUT_FAIL';
export const FETCH_ACCOUNT_INFORMATION_SUCCESS = 'FETCH_ACCOUNT_INFORMATION_SUCCESS';
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
export const CHECK_AUTHENTICATION_SUCCESS = 'CHECK_AUTHENTICATION_SUCCESS';
export const CHECK_AUTHENTICATION_FAIL = 'CHECK_AUTHENTICATION_FAIL';
export const ACCOUNT_RESET_PASSWORD = 'ACCOUNT_RESET_PASSWORD';
export const ACCOUNT_RESET_PASSWORD_SUCCESS = 'ACCOUNT_RESET_PASSWORD_SUCCESS';
export const ACCOUNT_RESET_PASSWORD_FAIL = 'ACCOUNT_RESET_PASSWORD_FAIL';
export const ACCOUNT_RESET_PASSWORD_CHECK = 'ACCOUNT_RESET_PASSWORD_CHECK';
export const ACCOUNT_RESET_PASSWORD_CHECK_SUCCESS = 'ACCOUNT_RESET_PASSWORD_CHECK_SUCCESS';
export const ACCOUNT_RESET_PASSWORD_CHECK_FAIL = 'ACCOUNT_RESET_PASSWORD_CHECK_FAIL';
export const ACCOUNT_CREATE_PASSWORD_CHECK = 'ACCOUNT_CREATE_PASSWORD_CHECK';
export const ACCOUNT_CREATE_PASSWORD_CHECK_SUCCESS = 'ACCOUNT_CREATE_PASSWORD_CHECK_SUCCESS';
export const ACCOUNT_CREATE_PASSWORD_CHECK_FAIL = 'ACCOUNT_CREATE_PASSWORD_CHECK_FAIL';

export const ACCOUNT_SIGN_UP = 'ACCOUNT_SIGN_UP';
export const ACCOUNT_SIGN_UP_SUCCESS = 'ACCOUNT_SIGN_UP_SUCCESS';
export const ACCOUNT_SIGN_UP_FAIL = 'ACCOUNT_SIGN_UP_FAIL';
export const ACCOUNT_GET_AUTH_TOKEN_SUCCESS = 'ACCOUNT_GET_AUTH_TOKEN_SUCCESS';
export const ACCOUNT_SEND_CODE = 'ACCOUNT_SEND_CODE';
export const ACCOUNT_SEND_CODE_SUCCESS = 'ACCOUNT_SEND_CODE_SUCCESS';
export const ACCOUNT_SEND_CODE_FAIL = 'ACCOUNT_SEND_CODE_FAIL';
export const ACCOUNT_TWO_FACTOR_LOGIN = 'ACCOUNT_TWO_FACTOR_LOGIN';
export const ACCOUNT_TWO_FACTOR_LOGIN_SUCCESS = 'ACCOUNT_TWO_FACTOR_LOGIN_SUCCESS';
export const ACCOUNT_TWO_FACTOR_LOGIN_FAIL = 'ACCOUNT_TWO_FACTOR_LOGIN_FAIL';

export const ACCOUNT_SIGN_UP_EMAIL_CHECK = 'ACCOUNT_SIGN_UP_EMAIL_CHECK';
export const ACCOUNT_SIGN_UP_EMAIL_CHECK_SUCCESS = 'ACCOUNT_SIGN_UP_EMAIL_CHECK_SUCCESS';
export const ACCOUNT_SIGN_UP_EMAIL_CHECK_FAIL = 'ACCOUNT_SIGN_UP_EMAIL_CHECK_FAIL';
export const ACCOUNT_SIGN_UP_SEND_CODE = 'ACCOUNT_SIGN_UP_SEND_CODE';
export const ACCOUNT_SIGN_UP_SEND_CODE_SUCCESS = 'ACCOUNT_SIGN_UP_SEND_CODE_SUCCESS';
export const ACCOUNT_SIGN_UP_SEND_CODE_FAIL = 'ACCOUNT_SIGN_UP_SEND_CODE_FAIL';
export const ACCOUNT_SIGN_UP_CODE_CHECK = 'ACCOUNT_SIGN_UP_CODE_CHECK';
export const ACCOUNT_SIGN_UP_CODE_CHECK_SUCCESS = 'ACCOUNT_SIGN_UP_CODE_CHECK_SUCCESS';
export const ACCOUNT_SIGN_UP_CODE_CHECK_FAIL = 'ACCOUNT_SIGN_UP_CODE_CHECK_FAIL';
export const ACCOUNT_SIGN_UP_COMPANY = 'ACCOUNT_SIGN_UP_COMPANY';
export const ACCOUNT_SIGN_UP_COMPANY_SUCCESS = 'ACCOUNT_SIGN_UP_COMPANY_SUCCESS';
export const ACCOUNT_SIGN_UP_COMPANY_FAIL = 'ACCOUNT_SIGN_UP_COMPANY_FAIL';

// Reducer
export default function accountReducer(state = { authenticated: null }, action) {
  const { type, payload } = action;
  switch (type) {
    case ACCOUNT_LOGIN_SUCCESS:
    case CHECK_AUTHENTICATION_SUCCESS:
    case ACCOUNT_TWO_FACTOR_LOGIN_SUCCESS:
      return {
        ...state,
        ...payload,
        authenticated: true,
      };
    case ACCOUNT_LOGOUT_SUCCESS:
    case ACCOUNT_LOGIN_FAIL:
    case CHECK_AUTHENTICATION_FAIL:
    case ACCOUNT_TWO_FACTOR_LOGIN_FAIL:
      return {
        ...state,
        authenticated: false,
      };
    case FETCH_ACCOUNT_INFORMATION_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}

// Action Creators
export function accountLogin(payload) {
  return { type: ACCOUNT_LOGIN, payload };
}

export function accountLoginSuccess(payload) {
  return { type: ACCOUNT_LOGIN_SUCCESS, payload };
}

export function accountLoginFail(payload) {
  return { type: ACCOUNT_LOGIN_FAIL, payload };
}

export function accountGetAuthTokenSuccess(payload) {
  return { type: ACCOUNT_GET_AUTH_TOKEN_SUCCESS, payload };
}

export function accountSendCode(payload) {
  return { type: ACCOUNT_SEND_CODE, payload };
}

export function accountSendCodeSuccess(payload) {
  return { type: ACCOUNT_SEND_CODE_SUCCESS, payload };
}

export function accountSendCodeFail(payload) {
  return { type: ACCOUNT_SEND_CODE_FAIL, payload };
}

export function accountTwoFactorLogin(payload) {
  return { type: ACCOUNT_TWO_FACTOR_LOGIN, payload };
}

export function accountTwoFactorLoginSuccess(payload) {
  return { type: ACCOUNT_TWO_FACTOR_LOGIN_SUCCESS, payload };
}

export function accountTwoFactorLoginFail(payload) {
  return { type: ACCOUNT_TWO_FACTOR_LOGIN_FAIL, payload };
}

export function accountLogout(payload) {
  return { type: ACCOUNT_LOGOUT, payload };
}

export function accountLogoutSuccess() {
  return { type: ACCOUNT_LOGOUT_SUCCESS };
}

export function accountLogoutFail(payload) {
  return { type: ACCOUNT_LOGOUT_FAIL, payload };
}

export function fetchAccountInformationSuccess(payload) {
  return { type: FETCH_ACCOUNT_INFORMATION_SUCCESS, payload };
}

export function checkAuthentication(payload) {
  return { type: CHECK_AUTHENTICATION, payload };
}

export function checkAuthenticationSuccess(payload) {
  return { type: CHECK_AUTHENTICATION_SUCCESS, payload };
}

export function checkAuthenticationFail(payload) {
  return { type: CHECK_AUTHENTICATION_FAIL, payload };
}

export function accountResetPassword(payload) {
  return { type: ACCOUNT_RESET_PASSWORD, payload };
}

export function accountResetPasswordSuccess() {
  return { type: ACCOUNT_RESET_PASSWORD_SUCCESS };
}

export function accountResetPasswordFail(payload) {
  return { type: ACCOUNT_RESET_PASSWORD_FAIL, payload };
}

export function accountResetPasswordCheck(payload) {
  return { type: ACCOUNT_RESET_PASSWORD_CHECK, payload };
}

export function accountResetPasswordCheckSuccess() {
  return { type: ACCOUNT_RESET_PASSWORD_CHECK_SUCCESS };
}

export function accountResetPasswordCheckFail(payload) {
  return { type: ACCOUNT_RESET_PASSWORD_CHECK_FAIL, payload };
}

export function accountCreatePasswordCheck(payload) {
  return { type: ACCOUNT_CREATE_PASSWORD_CHECK, payload };
}

export function accountCreatePasswordCheckSuccess() {
  return { type: ACCOUNT_CREATE_PASSWORD_CHECK_SUCCESS };
}

export function accountCreatePasswordCheckFail(payload) {
  return { type: ACCOUNT_CREATE_PASSWORD_CHECK_FAIL, payload };
}

export function accountSignUp(payload) {
  return { type: ACCOUNT_SIGN_UP, payload };
}

export function accountSignUpSuccess(payload) {
  return { type: ACCOUNT_SIGN_UP_SUCCESS, payload };
}

export function accountSignUpFail(payload) {
  return { type: ACCOUNT_SIGN_UP_FAIL, payload };
}

export function accountSignUpEmailCheck(payload) {
  return { type: ACCOUNT_SIGN_UP_EMAIL_CHECK, payload };
}

export function accountSignUpEmailCheckSuccess(payload) {
  return { type: ACCOUNT_SIGN_UP_EMAIL_CHECK_SUCCESS, payload };
}

export function accountSignUpEmailCheckFail(payload) {
  return { type: ACCOUNT_SIGN_UP_EMAIL_CHECK_FAIL, payload };
}

export function accountSignUpSendCode(payload) {
  return { type: ACCOUNT_SIGN_UP_SEND_CODE, payload };
}

export function accountSignUpSendCodeSuccess(payload) {
  return { type: ACCOUNT_SIGN_UP_SEND_CODE_SUCCESS, payload };
}

export function accountSignUpSendCodeFail(payload) {
  return { type: ACCOUNT_SIGN_UP_SEND_CODE_FAIL, payload };
}

export function accountSignUpCodeCheck(payload) {
  return { type: ACCOUNT_SIGN_UP_CODE_CHECK, payload };
}

export function accountSignUpCodeCheckSuccess(payload) {
  return { type: ACCOUNT_SIGN_UP_CODE_CHECK_SUCCESS, payload };
}

export function accountSignUpCodeCheckFail(payload) {
  return { type: ACCOUNT_SIGN_UP_CODE_CHECK_FAIL, payload };
}

export function accountSignUpCompany(payload) {
  return { type: ACCOUNT_SIGN_UP_COMPANY, payload };
}

export function accountSignUpCompanySuccess(payload) {
  return { type: ACCOUNT_SIGN_UP_COMPANY_SUCCESS, payload };
}

export function accountSignUpCompanyFail(payload) {
  return { type: ACCOUNT_SIGN_UP_COMPANY_FAIL, payload };
}

// Requests
export function requestAccountLogin(payload) {
  return callApi('security/login/', 'POST', payload);
}

export function requestAccountTokenLogin({ url, authorization }) {
  return callApi(process.env.REACT_APP_API_ROOT ? 'security/token_login/' : url, 'POST', null, false, { authorization });
}

export function requestAccountLogout() {
  return callApi('security/logout/');
}

export function requestAccountSendCode(payload) {
  return callApi('security/send_code/', 'POST', payload);
}

export function requestAccountTwoFactorLogin(payload) {
  return callApi('security/two_factor_auth/', 'POST', payload);
}

export function requestСheckAuthentication() {
  return callApi('security/authentication_check/', 'POST');
}

export function requestAccountResetPassword(payload) {
  return callApi('security/reload_password/', 'POST', payload);
}

export function requestAccountResetPasswordCheck(payload) {
  return callApi('security/reload_password_check/', 'POST', payload);
}

export function requestAccountCreatePasswordCheck(payload) {
  return callApi('security/new_user_verify_check/', 'POST', payload);
}

export function requestAccountSignUp(payload) {
  return callApi('new_client/soft_create_client/', 'POST', payload);
}

export function requestAccountSignUpSendEmail(payload) {
  return callApi('new_client/send_email_token/', 'POST', payload);
}

export function requestAccountSignUpEmailCheck(payload) {
  return callApi('new_client/check_email/', 'POST', payload);
}

export function requestAccountSignUpSendCode(payload) {
  return callApi('new_client/send_phone_code/', 'POST', payload);
}

export function requestAccountSignUpCodeCheck(payload) {
  return callApi('new_client/check_phone_code/', 'POST', payload);
}

export function requestAccountSignUpCompany(payload) {
  return callApi('new_client/create_client/', 'POST', payload);
}

// Sagas
function* accountLoginSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountLogin, values);
    if (res.data.auth_id) {
      yield put(accountGetAuthTokenSuccess({
        auth_id: res.data.auth_id,
      }));
    } else {
      const tokenLoginRes = yield call(requestAccountTokenLogin, res.data);
      
      if (tokenLoginRes.data.success) {
        yield put(accountLoginSuccess(res.user_info));
        if (resolve) {
          resolve(res.data);
        }
      } else {
        yield put(accountTwoFactorLoginFail(res.data));
        if (reject) {
          reject(res.data);
        }
      }
    }
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve({
        ...res.user_info,
        ...res.data.auth_id ? { auth_id: res.data.auth_id } : {},
      });
    }
  } catch (err) {
    yield put(accountLoginFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* accountSendCodeSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountSendCode, values);
    if (res.data.success) {
      yield put(accountSendCodeSuccess());
      if (resolve) {
        resolve(res.data);
      }
      yield put(addNotification({
        message: `Authentication code was successfully sent to your ${values.Transport}`,
        variant: 'success',
      }));
    } else {
      yield put(accountSendCodeFail(res.data));
      if (reject) {
        reject(res.data);
      }
      yield put(addNotification({
        message: `Failed to send authentication code to your ${values.Transport}`,
        variant: 'warning',
      }));
    }
  } catch (err) {
    yield put(accountSendCodeFail(err.data));
    if (reject) {
      reject(err.data);
    }
    yield put(addNotification({
      message: `Failed to send authentication code to your ${values.Transport}`,
      variant: 'warning',
    }));
  }
}

function* accountTwoFactorLoginSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountTwoFactorLogin, values);
    if (res.data.authorization) {
      
      const tokenLoginRes = yield call(requestAccountTokenLogin, res.data);
      if (tokenLoginRes.data.success) {
        yield put(accountTwoFactorLoginSuccess(res.user_info));
        if (resolve) {
          resolve(res.data);
        }
      } else {
        yield put(accountTwoFactorLoginFail(res.data));
        if (reject) {
          reject(res.data);
        }
      }
    } else {
      yield put(accountTwoFactorLoginFail(res.data));
      if (reject) {
        reject(res.data);
      }
    }
    yield put(fetchAppInfoSuccess(res.app_info));
    
  } catch (err) {
    yield put(accountTwoFactorLoginFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* accountLogoutSaga(action) {
  try {
    yield call(requestAccountLogout);
    yield put(accountLogoutSuccess());
    if (action.payload && action.payload.resolve) {
      action.payload.resolve();
    }
  } catch (err) {
    yield put(accountLogoutFail(err.data));
    if (action.payload && action.payload.reject) {
      action.payload.reject(err.data);
    }
  }
}

function* accountLoginFailSaga() {
  yield put(accountLoginFail());
}

function* checkAuthenticationSaga() {
  try {
    const res = yield call(requestСheckAuthentication);
    if (res.data.success === true) {
      yield put(checkAuthenticationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    } else {
      yield put(fetchAppInfoSuccess(res.app_info));
      yield put(checkAuthenticationFail());
    }
  } catch (err) {
    yield put(checkAuthenticationFail(err.data));
  }
}

function* accountResetPasswordSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountResetPassword, values);
    yield put(accountResetPasswordSuccess());
    yield put(addNotification({
      message: `Recovery link was successfully sent to ${values.Email}`,
      variant: 'success',
    }));
    if (resolve) {
      resolve(res);
    }
  } catch (err) {
    yield put(accountResetPasswordFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* accountResetPasswordCheckSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountResetPasswordCheck, values);
    if (res.data.authorization) {      
      const tokenLoginRes = yield call(requestAccountTokenLogin, res.data);
      if (tokenLoginRes.data.success) {
        yield put(accountLoginSuccess(tokenLoginRes.user_info));
        yield put(fetchAppInfoSuccess(tokenLoginRes.app_info));
        yield put(accountResetPasswordCheckSuccess());
        if (resolve) {
          resolve(res.data);
        }
      } else {
        yield put(accountResetPasswordCheckFail(res.data));
        if (reject) {
          reject(res.data);
        }
      }
    } else {
      yield put(accountResetPasswordCheckFail(res.data));
      if (reject) {
        reject(res.data);
      }
    }
  } catch (err) {
    yield put(accountResetPasswordCheckFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* accountCreatePasswordCheckSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountCreatePasswordCheck, values);

    if (res.data.authorization) {      
      const tokenLoginRes = yield call(requestAccountTokenLogin, res.data);
      if (tokenLoginRes.data.success) {
        yield put(accountLoginSuccess(tokenLoginRes.user_info));
        yield put(fetchAppInfoSuccess(tokenLoginRes.app_info));
        yield put(accountCreatePasswordCheckSuccess());
        if (resolve) {
          resolve(res.data);
        }
      } else {
        yield put(accountCreatePasswordCheckFail(res.data));
        if (reject) {
          reject(res.data);
        }
      }
    } else {
      yield put(accountCreatePasswordCheckFail(res.data));
      if (reject) {
        reject(res.data);
      }
    }
  } catch (err) {
    yield put(accountCreatePasswordCheckFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* accountSignUpSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountSignUp, values);
    const emailRes = yield call(requestAccountSignUpSendEmail, { Email: values.Email });
    yield put(accountSignUpSuccess());
    yield put(addNotification({
      message: `Sign Up accepted. Confirmation send to ${values.Email}`,
      variant: 'success',
    }));
    if (resolve) {
      resolve(res);
    }
  } catch (err) {
    yield put(accountSignUpFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* accountSignUpEmailCheckSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountSignUpEmailCheck, values);
    yield put(accountSignUpEmailCheckSuccess());
    if (resolve) {
      resolve(res);
    }
  } catch (err) {
    yield put(accountSignUpEmailCheckFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* accountSignUpSendCodeSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountSignUpSendCode, values);
    yield put(accountSignUpSendCodeSuccess());
    if (resolve) {
      resolve(res);
    }
    yield put(addNotification({
      message: 'Authentication code was successfully sent to your Mobile Phone',
      variant: 'success',
    }));
  } catch (err) {
    yield put(accountSignUpSendCodeFail(err.data));
    if (reject) {
      reject(err.data);
    }
    yield put(addNotification({
      message: 'Failed to send authentication code to your Mobile Phone',
      variant: 'warning',
    }));
  }
}

function* accountSignUpCodeCheckSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountSignUpCodeCheck, values);
    yield put(accountSignUpCodeCheckSuccess());
    if (resolve) {
      resolve(res);
    }
  } catch (err) {
    yield put(accountSignUpCodeCheckFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* accountSignUpCompanySaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestAccountSignUpCompany, values);
    if (res.data.auth_id) {
      yield put(accountGetAuthTokenSuccess({
        auth_id: res.data.auth_id,
      }));
    } else {
      const tokenLoginRes = yield call(requestAccountTokenLogin, res.data);
      
      if (tokenLoginRes.data.success) {
        yield put(accountLoginSuccess(res.user_info));
        if (resolve) {
          resolve(res.data);
        }
      } else {
        yield put(accountTwoFactorLoginFail(res.data));
        if (reject) {
          reject(res.data);
        }
      }
    }
    yield put(accountSignUpCompanySuccess());
    if (resolve) {
      resolve(res);
    }
  } catch (err) {
    yield put(accountSignUpCompanyFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* accountSaga() {
  yield takeEvery(ACCOUNT_LOGIN, accountLoginSaga);
  yield takeEvery(ACCOUNT_LOGOUT, accountLogoutSaga);
  yield takeEvery(ACCOUNT_SEND_CODE, accountSendCodeSaga);
  yield takeEvery(ACCOUNT_TWO_FACTOR_LOGIN, accountTwoFactorLoginSaga);
  yield takeEvery(CHECK_AUTHENTICATION, checkAuthenticationSaga);
  yield takeEvery(action =>
    (action.type.indexOf('FAIL') !== -1)
      && action.payload
      && (action.payload.error === 'Need authorisation'
      || action.payload.description === 'Need authorisation'),
  accountLoginFailSaga);
  yield takeEvery(ACCOUNT_RESET_PASSWORD, accountResetPasswordSaga);
  yield takeEvery(ACCOUNT_RESET_PASSWORD_CHECK, accountResetPasswordCheckSaga);
  yield takeEvery(ACCOUNT_CREATE_PASSWORD_CHECK, accountCreatePasswordCheckSaga);
  yield takeEvery(ACCOUNT_SIGN_UP, accountSignUpSaga);
  yield takeEvery(ACCOUNT_SIGN_UP_EMAIL_CHECK, accountSignUpEmailCheckSaga);
  yield takeEvery(ACCOUNT_SIGN_UP_SEND_CODE, accountSignUpSendCodeSaga);
  yield takeEvery(ACCOUNT_SIGN_UP_CODE_CHECK, accountSignUpCodeCheckSaga);
  yield takeEvery(ACCOUNT_SIGN_UP_COMPANY, accountSignUpCompanySaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/account.js